<script>
  let {
    open = false, title, message,
    confirmLabel = 'Confirm', cancelLabel = 'Cancel',
    variant = 'danger', onConfirm, onCancel,
    // Optional extra content between the message and the buttons — e.g. a
    // required justification field. Without this, a caller passing a snippet
    // gets it silently dropped, and any server-side requirement it was
    // collecting becomes impossible to satisfy from the UI.
    children = null,
    // Lets a caller gate confirmation on that content being filled in.
    confirmDisabled = false,
  } = $props();

  function onKey(e) { if (e.key === 'Escape') onCancel?.(); }
</script>

<svelte:window on:keydown={open ? onKey : undefined} />

{#if open}
  <!-- Backdrop dismissal is a convenience; Escape (bound on <svelte:window> above)
       is the keyboard-accessible equivalent, so no key handler is needed here.
       Comparing target to currentTarget means only clicks on the backdrop itself
       dismiss — no stopPropagation handler on the dialog, which would otherwise
       put a click listener on a non-interactive element. -->
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
       role="presentation"
       onclick={(e) => { if (e.target === e.currentTarget) onCancel?.(); }}>
    <div class="p-card w-full max-w-md p-6" role="dialog" aria-modal="true"
         aria-labelledby="confirm-title" tabindex="-1">
      <h2 id="confirm-title" class="text-base font-semibold">{title}</h2>
      <p class="mt-2 text-sm p-muted">{message}</p>
      {#if children}{@render children()}{/if}
      <div class="mt-6 flex justify-end gap-2">
        <button type="button" class="p-btn p-btn-quiet" onclick={() => onCancel?.()}>{cancelLabel}</button>
        <button type="button" class="p-btn"
                class:p-btn-danger={variant === 'danger'}
                class:p-btn-primary={variant !== 'danger'}
                disabled={confirmDisabled}
                onclick={() => onConfirm?.()}>{confirmLabel}</button>
      </div>
    </div>
  </div>
{/if}
